export const localizedContent = {
  en: {
    meta: { label: "English", shortLabel: "EN" },
    navigation: {
      links: [
        { name: "Home", href: "#home" },
        { name: "Summary", href: "#summary" },
        { name: "Availability", href: "#availability" },
        { name: "Experience", href: "#experience" },
        { name: "Skills", href: "#skills" },
        { name: "Projects", href: "#projects" },
        { name: "Contact", href: "#contact" },
      ],
      languageLabel: "Language",
      languageSwitcherAria: "Change language",
      languageOptions: [
        { code: "en", label: "English", shortLabel: "EN" },
        { code: "id", label: "Indonesian", shortLabel: "ID" },
      ],
    },
    hero: {
      badgeText: "Open to work",
      downloadCta: "Download CV",
      scrollText: "Scroll",
      locationPrefix: "Based in",
      loadingPortrait: "Loading portrait",
      portraitUnavailableTitle: "Portrait unavailable",
      portraitUnavailableSubtitle: "Please double-check the photo asset",
    },
    summary: {
      badge: "Background",
      heading: "Education & Languages",
      educationTitle: "Education",
      teachingAssistantLabel: "Teaching Assistant",
      awardsLabel: "Awards & Achievements",
      languagesCardTitle: "Languages",
      languagesCardDescription: "Communication Skills",
      stats: {
        languagesLabel: "Languages",
        projectsLabel: "Projects",
        gpaLabel: "GPA",
        projectsValue: "20+",
      },
    },
    availability: {
      badge: "About",
      kicker: "Available for UI/UX",
      heading:
        "I am available for apps and digital systems development projects.",
      description:
        "Designing product experiences that feel clear, intentional, and easy to use. I partner closely to translate goals into polished interfaces.",
      status: {
        label: "Currently available",
        note: "Open for apps and product design collaborations",
      },
      highlights: ["UX Research", "Design Systems", "High-fidelity Prototypes"],
      stats: [
        { label: "Projects", value: "20+" },
        { label: "UI Screens", value: "150+" },
        { label: "Industries", value: "6+" },
      ],
      ctaPrimary: "Get Started",
      ctaSecondary: "View Portfolio",
      imageAlt: "Portrait preview",
      loadingImage: "Loading portrait",
      imageUnavailableTitle: "Portrait unavailable",
      imageUnavailableSubtitle: "Please double-check the photo asset",
    },
    experience: {
      badge: "Career Journey",
      heading: "Professional Experience",
      description:
        "Building innovative digital solutions across multiple industries",
    },
    skillsSection: {
      badge: "Technical Arsenal",
      heading: "Skills & Technologies",
      description: "Modern tech stack for building scalable applications",
      categories: [
        {
          id: "frontend",
          name: "Frontend",
          color: "from-blue-500/20 to-cyan-500/20",
        },
        {
          id: "backend",
          name: "Backend",
          color: "from-green-500/20 to-emerald-500/20",
        },
        {
          id: "mobile",
          name: "Mobile",
          color: "from-purple-500/20 to-pink-500/20",
        },
        {
          id: "database",
          name: "Database",
          color: "from-blue-600/20 to-cyan-500/20",
        },
        {
          id: "devops",
          name: "DevOps",
          color: "from-red-500/20 to-rose-500/20",
        },
        {
          id: "design",
          name: "Design",
          color: "from-indigo-500/20 to-violet-500/20",
        },
      ],
    },
    projectsSection: {
      badge: "Portfolio Showcase",
      heading: "Featured Projects",
      description:
        "Real-world applications across healthtech, mobility, agriculture, and mobile platforms",
      loadingPreview: "Loading preview",
      previewUnavailable: "Preview unavailable",
      assetAttention: "Asset path needs attention",
      viewLive: "View Live",
      liveUnavailable: "Live link unavailable",
      viewLiveTitlePrefix: "View",
      repoUnavailable: "Repository unavailable",
      repoTitlePrefix: "Repository for",
      repoAriaPrefix: "Open repository for",
      skeletonPreparing: "Preparing preview",
    },
    contactSection: {
      badge: "Get In Touch",
      heading: "Let's Work Together",
      description:
        "Have a project in mind? Let's discuss how we can collaborate",
      infoTitle: "Contact Information",
      infoDescription:
        "I'm always interested in hearing about new projects and opportunities. Feel free to reach out!",
      details: {
        email: "Email",
        phone: "Phone",
        location: "Location",
        follow: "Follow me on",
        linkedin: "LinkedIn",
        github: "GitHub",
      },
      form: {
        name: {
          label: "Your Name",
          placeholder: "John Doe",
        },
        email: {
          label: "Email Address",
          placeholder: "john@example.com",
        },
        subject: {
          label: "Subject",
          placeholder: "Project Discussion",
        },
        message: {
          label: "Message",
          placeholder: "Tell me about your project...",
        },
        submitIdle: "Send Message",
        submitSending: "Sending...",
      },
      toast: {
        title: "Message Sent!",
        description: "Thank you for reaching out. I'll get back to you soon.",
      },
    },
    footer: {
      builtWith: "Built with",
      using: "using React & Tailwind CSS",
      rights: "All rights reserved.",
      versionLabel: "Version",
      quickLinks: [
        { name: "Home", href: "#home" },
        { name: "Projects", href: "#projects" },
        { name: "Contact", href: "#contact" },
      ],
    },
    personalInfo: {
      name: "Rifki Rusdi Satma Putra",
      title: "Fullstack Developer",
      bio: "Fullstack Developer with experience building digital solutions in healthtech, mobility, agriculture, and education.",
      location: "Mataram, Indonesia",
      email: "rifkirusdisatmaputra@gmail.com",
      phone: "+62 877-1294-6545",
      linkedin: "linkedin.com/in/rifkirusdi30",
      github: "github.com/RusdyZain",
      cvUrl:
        "https://docs.google.com/document/d/1--JL87xANrbNkV1Tzlzq3BOPUeFQI-G-/edit?usp=sharing&ouid=108859602331194458341&rtpof=true&sd=true",
      portrait: "/rusdy.png",
    },
    experiences: [
      {
        id: 0,
        role: "Founder & Owner - Nusadex",
        company: "PT Candrawati Ventures Group",
        period: "2025 - Present",
        highlights: [
          "Founded and grew Nusadex as a digital solutions development service under the PT Candrawati Ventures ecosystem.",
          "Led the design and development of digital products such as websites, web applications, and technology-driven business systems.",
          "Managed business development strategy, client partnerships, and software delivery operations.",
          "Directed the adoption of modern technologies to help organizations and MSMEs accelerate digital transformation.",
        ],
      },
      {
        id: 1,
        role: "Fullstack Developer",
        company: "Biddokkes POLDA NTB",
        period: "2024 - Present",
        highlights: [
          "Developed clinical health system integrated with BPJS PCare",
          "Implemented patient records and drug inventory management",
          "Built analytics dashboard for healthcare operations",
        ],
      },
      {
        id: 2,
        role: "Fullstack Developer",
        company: "Gridwiz Energy & Mobility",
        period: "2024 - 2025",
        highlights: [
          "Developed e-bike rental platform with Next.js and NestJS",
          "Implemented real-time booking and payment system",
          "Deployed on VPS with Nginx configuration",
        ],
      },
      {
        id: 3,
        role: "Chief Technology Officer",
        company: "AyoTani",
        period: "2024 - 2025",
        highlights: [
          "Led technical team in building agritech platform",
          "Architected full-stack solution for farmers and suppliers",
          "Managed technology roadmap and infrastructure",
        ],
      },
      {
        id: 4,
        role: "Flutter Developer",
        company: "MojadiApp",
        period: "2023 - 2024",
        highlights: [
          "Developed cross-platform mobile application",
          "Integrated Firebase backend services",
          "Implemented responsive UI with Flutter widgets",
        ],
      },
      {
        id: 5,
        role: "Fullstack Engineering Intern",
        company: "Bank Mandiri x Rakamin",
        period: "2023",
        highlights: [
          "Participated in enterprise software development",
          "Learned banking system architecture",
          "Collaborated with cross-functional teams",
        ],
      },
    ],
    skills: [
      { name: "Next.js (TypeScript)", category: "frontend", icon: "Code2" },
      { name: "React.js", category: "frontend", icon: "Code" },
      { name: "Vite + React", category: "frontend", icon: "Zap" },
      { name: "HTML/CSS/JavaScript", category: "frontend", icon: "Globe" },
      { name: "Tailwind CSS", category: "frontend", icon: "Palette" },
      { name: "Bootstrap", category: "frontend", icon: "Layout" },
      { name: "ShadCN", category: "frontend", icon: "Component" },
      {
        name: "Responsive Layout Techniques",
        category: "design",
        icon: "LayoutDashboard",
      },
      {
        name: "Figma & Dribbble-Style UI",
        category: "design",
        icon: "PenTool",
      },
      { name: "Flutter", category: "mobile", icon: "Smartphone" },
      { name: "Node.js", category: "backend", icon: "Cpu" },
      { name: "Express.js", category: "backend", icon: "Database" },
      { name: "NestJS", category: "backend", icon: "Server" },
      { name: "Native PHP", category: "backend", icon: "FileCode2" },
      { name: "Firebase", category: "backend", icon: "Cloud" },
      { name: "PostgreSQL", category: "database", icon: "Database" },
      { name: "MySQL", category: "database", icon: "HardDrive" },
      { name: "MongoDB", category: "database", icon: "Leaf" },
      { name: "Docker", category: "devops", icon: "Container" },
      { name: "VPS + Nginx Deployment", category: "devops", icon: "ServerCog" },
      { name: "Vercel Hosting", category: "devops", icon: "Triangle" },
      { name: "cPanel Hosting", category: "devops", icon: "PanelLeft" },
      { name: "Nginx", category: "devops", icon: "Network" },
      { name: "Git", category: "devops", icon: "GitBranch" },
      { name: "CI/CD", category: "devops", icon: "Workflow" },
      { name: "BPJS PCare API", category: "integration", icon: "ShieldCheck" },
      { name: "GPT API (OpenAI)", category: "integration", icon: "Brain" },
      { name: "Google Voice-to-Speech", category: "integration", icon: "Mic2" },
      { name: "Telegram Bot API", category: "integration", icon: "Send" },
      { name: "Google Maps Platform", category: "integration", icon: "MapPin" },
      {
        name: "Coordinate Region Mapping",
        category: "integration",
        icon: "Route",
      },
      { name: "YouTube API", category: "integration", icon: "Youtube" },
    ],
    languages: [
      { name: "Indonesian", level: 100, proficiency: "Native" },
      { name: "English", level: 30, proficiency: "Working Proficiency" },
      { name: "Arabic", level: 40, proficiency: "Basic" },
    ],
    education: {
      degree: "Bachelor of Informatics Engineering",
      university: "Universitas Mataram",
      gpa: "3.88/4.00",
      period: "2020 - 2024",
      roles: [
        "Teaching Assistant - Algorithms & Data Structures",
        "Teaching Assistant - Digital Systems",
        "Teaching Assistant - Digital Image Processing",
      ],
      awards: [
        "GEMASTIK Finalist - National IT Competition",
        "Best Paper Award - Academic Conference",
        "Multiple National Competition Participations",
      ],
    },
    projects: [
      {
        id: 1,
        title: "AkuSehat",
        subtitle: "Clinical Healthtech Platform",
        description:
          "Comprehensive digital health system integrated with BPJS PCare, featuring patient records management, drug inventory system, and analytics dashboard for healthcare operations.",
        tech: ["React Vite", "Express.js", "PostgreSQL", "Node.js"],
        image: "/akusehat.png",
        category: "Healthtech",
        color: "from-blue-600/20 to-cyan-500/20",
        liveUrl: "https://akusehat-poldantb-unram.icu",
        repoUrl: "https://github.com/ISENA-FKTP",
      },
      {
        id: 2,
        title: "E-Bike Rental Platform",
        subtitle: "Gridwiz Dashboard Service - Energy and Mobility Indonesia",
        description:
          "Next.js frontend with NestJS backend for electric bike rental service. Features real-time booking, payment integration, and VPS deployment with Nginx configuration.",
        tech: ["Next.js", "NestJS", "PostgreSQL", "Nginx"],
        image: "/gridwiz.png",
        category: "Mobility",
        color: "from-blue-500/20 to-cyan-500/20",
        liveUrl: "https://gridwizenm.com",
        repoUrl: "https://github.com/GridWiz-Apps",
      },
      {
        id: 3,
        title: "AyoTani",
        subtitle: "Agritech Platform",
        description:
          "Full-stack web platform connecting farmers with suppliers. Includes marketplace features, inventory management, and logistics coordination for agricultural products.",
        tech: ["React", "Node.js", "MongoDB", "Express"],
        image: "/ayotani.png",
        category: "Agritech",
        color: "from-green-500/20 to-emerald-500/20",
        liveUrl: "#",
        repoUrl: "https://github.com/Ayotani-Unram",
      },
      {
        id: 4,
        title: "KarirTerbuka",
        subtitle: "Job Vacancy Platform",
        description:
          "Inclusive job vacancy website that connects disability-friendly employers with general applicants. Built with modern web stack to ensure accessibility, responsive UX, and real-time listing updates.",
        tech: [
          "TypeScript",
          "Tailwind CSS",
          "React.js",
          "Next.js",
          "MySQL",
          "Vercel",
        ],
        image: "/karirterbuka.png",
        category: "Job Portal",
        color: "from-purple-500/20 to-pink-500/20",
        liveUrl: "https://karir-terbuka.vercel.app",
        repoUrl: "https://github.com/RusdyZain/KarirTerbuka",
      },
    ],
  },
  id: {
    meta: { label: "Bahasa Indonesia", shortLabel: "ID" },
    navigation: {
      links: [
        { name: "Beranda", href: "#home" },
        { name: "Ringkasan", href: "#summary" },
        { name: "Ketersediaan", href: "#availability" },
        { name: "Pengalaman", href: "#experience" },
        { name: "Keahlian", href: "#skills" },
        { name: "Proyek", href: "#projects" },
        { name: "Kontak", href: "#contact" },
      ],
      languageLabel: "Bahasa",
      languageSwitcherAria: "Ganti bahasa",
      languageOptions: [
        { code: "en", label: "Inggris", shortLabel: "EN" },
        { code: "id", label: "Indonesia", shortLabel: "ID" },
      ],
    },
    hero: {
      badgeText: "Siap bekerja",
      downloadCta: "Unduh CV",
      scrollText: "Gulir",
      locationPrefix: "Berbasis di",
      loadingPortrait: "Memuat foto",
      portraitUnavailableTitle: "Foto tidak tersedia",
      portraitUnavailableSubtitle: "Periksa kembali aset foto",
    },
    summary: {
      badge: "Latar Belakang",
      heading: "Pendidikan & Bahasa",
      educationTitle: "Pendidikan",
      teachingAssistantLabel: "Asisten Dosen",
      awardsLabel: "Penghargaan & Pencapaian",
      languagesCardTitle: "Bahasa",
      languagesCardDescription: "Kemampuan Komunikasi",
      stats: {
        languagesLabel: "Bahasa",
        projectsLabel: "Proyek",
        gpaLabel: "IPK",
        projectsValue: "20+",
      },
    },
    availability: {
      badge: "Tentang",
      kicker: "Tersedia untuk UI/UX",
      heading:
        "Saya tersedia untuk proyek pengembangan aplikasi web dan sistem digital.",
      description:
        "Berpengalaman mengembangkan platform berbasis React, Express, dan PostgreSQL untuk manajemen data, sistem kesehatan, dan aplikasi berbasis layanan. Saya fokus membangun sistem yang efisien, mudah digunakan, dan siap diimplementasikan dalam lingkungan nyata.",
      status: {
        label: "Sedang tersedia",
        note: "Terbuka untuk kolaborasi UI/UX dan desain produk",
      },
      highlights: ["Riset UX", "Design System", "Prototipe Hi-Fi"],
      stats: [
        { label: "Proyek", value: "20+" },
        { label: "UI Screen", value: "150+" },
        { label: "Industri", value: "6+" },
      ],
      ctaPrimary: "Mulai Proyek",
      ctaSecondary: "Lihat Portofolio",
      imageAlt: "Pratinjau foto",
      loadingImage: "Memuat foto",
      imageUnavailableTitle: "Foto tidak tersedia",
      imageUnavailableSubtitle: "Periksa kembali aset foto",
    },
    experience: {
      badge: "Perjalanan Karier",
      heading: "Pengalaman Profesional",
      description: "Membangun solusi digital inovatif di berbagai industri",
    },
    skillsSection: {
      badge: "Senjata Teknis",
      heading: "Keahlian & Teknologi",
      description: "Tumpukan teknologi modern untuk aplikasi skala besar",
      categories: [
        {
          id: "frontend",
          name: "Frontend",
          color: "from-blue-500/20 to-cyan-500/20",
        },
        {
          id: "backend",
          name: "Backend",
          color: "from-green-500/20 to-emerald-500/20",
        },
        {
          id: "mobile",
          name: "Mobile",
          color: "from-purple-500/20 to-pink-500/20",
        },
        {
          id: "database",
          name: "Basis Data",
          color: "from-blue-600/20 to-cyan-500/20",
        },
        {
          id: "devops",
          name: "DevOps",
          color: "from-red-500/20 to-rose-500/20",
        },
        {
          id: "design",
          name: "Desain",
          color: "from-indigo-500/20 to-violet-500/20",
        },
      ],
    },
    projectsSection: {
      badge: "Portofolio Unggulan",
      heading: "Proyek Pilihan",
      description:
        "Aplikasi nyata di kesehatan, mobilitas, pertanian, dan platform mobile",
      loadingPreview: "Memuat pratinjau",
      previewUnavailable: "Pratinjau tidak tersedia",
      assetAttention: "Periksa kembali lokasi aset",
      viewLive: "Lihat Live",
      liveUnavailable: "Tautan live belum tersedia",
      viewLiveTitlePrefix: "Lihat",
      repoUnavailable: "Repository belum tersedia",
      repoTitlePrefix: "Repository untuk",
      repoAriaPrefix: "Buka repository",
      skeletonPreparing: "Menyiapkan pratinjau",
    },
    contactSection: {
      badge: "Hubungi Saya",
      heading: "Mari Bekerja Sama",
      description:
        "Punya ide proyek? Mari diskusikan cara kita dapat berkolaborasi",
      infoTitle: "Informasi Kontak",
      infoDescription:
        "Saya senang berdiskusi tentang proyek baru dan peluang kolaborasi. Jangan ragu untuk menghubungi!",
      details: {
        email: "Surel",
        phone: "Telepon",
        location: "Lokasi",
        follow: "Ikuti saya di",
        linkedin: "LinkedIn",
        github: "GitHub",
      },
      form: {
        name: {
          label: "Nama Anda",
          placeholder: "John Doe",
        },
        email: {
          label: "Alamat Email",
          placeholder: "john@example.com",
        },
        subject: {
          label: "Subjek",
          placeholder: "Diskusi Proyek",
        },
        message: {
          label: "Pesan",
          placeholder: "Ceritakan kebutuhan proyek Anda...",
        },
        submitIdle: "Kirim Pesan",
        submitSending: "Mengirim...",
      },
      toast: {
        title: "Pesan terkirim!",
        description:
          "Terima kasih sudah menghubungi. Saya akan segera membalas.",
      },
    },
    footer: {
      builtWith: "Dibangun dengan",
      using: "menggunakan React & Tailwind CSS",
      rights: "Seluruh hak cipta dilindungi.",
      versionLabel: "Versi",
      quickLinks: [
        { name: "Beranda", href: "#home" },
        { name: "Proyek", href: "#projects" },
        { name: "Kontak", href: "#contact" },
      ],
    },
    personalInfo: {
      name: "Rifki Rusdi Satma Putra",
      title: "Pengembang Fullstack",
      bio: "Pengembang Fullstack berpengalaman membangun solusi digital di bidang kesehatan, mobilitas, pertanian, dan pendidikan.",
      location: "Mataram, Indonesia",
      email: "rifkirusdisatmaputra@gmail.com",
      phone: "+62 877-1294-6545",
      linkedin: "linkedin.com/in/rifkirusdi30",
      github: "github.com/rifkirusdi",
      cvUrl:
        "https://docs.google.com/document/d/1--JL87xANrbNkV1Tzlzq3BOPUeFQI-G-/edit?usp=sharing&ouid=108859602331194458341&rtpof=true&sd=true",
      portrait: "/rusdy.png",
    },
    experiences: [
      {
        id: 0,
        role: "Founder & Owner - Nusadex",
        company: "PT Candrawati Ventures Group",
        period: "2025 - Sekarang",
        highlights: [
          "Mendirikan dan mengembangkan Nusadex sebagai layanan pengembangan solusi digital di bawah ekosistem PT Candrawati Ventures.",
          "Memimpin perancangan dan pengembangan produk digital seperti website, aplikasi web, dan sistem bisnis berbasis teknologi.",
          "Mengelola strategi pengembangan bisnis, kemitraan klien, serta operasional proyek pengembangan perangkat lunak.",
          "Mengarahkan implementasi teknologi modern untuk membantu organisasi dan UMKM dalam melakukan transformasi digital.",
        ],
      },
      {
        id: 1,
        role: "Pengembang Fullstack",
        company: "Biddokkes POLDA NTB",
        period: "2024 - Sekarang",
        highlights: [
          "Membangun sistem klinik terintegrasi BPJS PCare",
          "Mengimplementasikan rekam medis dan manajemen inventaris obat",
          "Menyusun dashboard analitik operasional kesehatan",
        ],
      },
      {
        id: 2,
        role: "Pengembang Fullstack",
        company: "Gridwiz Energy & Mobility",
        period: "2024 - 2025",
        highlights: [
          "Mengembangkan platform sewa e-bike dengan Next.js dan NestJS",
          "Menerapkan pemesanan real-time dan sistem pembayaran",
          "Deploy di VPS dengan konfigurasi Nginx",
        ],
      },
      {
        id: 3,
        role: "Chief Technology Officer",
        company: "AyoTani",
        period: "2024 - 2025",
        highlights: [
          "Memimpin tim teknis membangun platform agritech",
          "Merancang solusi full-stack untuk petani dan pemasok",
          "Mengelola roadmap teknologi dan infrastruktur",
        ],
      },
      {
        id: 4,
        role: "Flutter Developer",
        company: "MojadiApp",
        period: "2023 - 2024",
        highlights: [
          "Mengembangkan aplikasi mobile lintas platform",
          "Integrasi backend Firebase",
          "Menerapkan UI responsif dengan widget Flutter",
        ],
      },
      {
        id: 5,
        role: "Fullstack Engineering Intern",
        company: "Bank Mandiri x Rakamin",
        period: "2023",
        highlights: [
          "Berpartisipasi dalam pengembangan perangkat lunak enterprise",
          "Mempelajari arsitektur sistem perbankan",
          "Kolaborasi dengan tim lintas fungsi",
        ],
      },
    ],
    skills: [
      { name: "Next.js (TypeScript)", category: "frontend", icon: "Code2" },
      { name: "React.js", category: "frontend", icon: "Code" },
      { name: "Vite + React", category: "frontend", icon: "Zap" },
      { name: "HTML/CSS/JavaScript", category: "frontend", icon: "Globe" },
      { name: "Tailwind CSS", category: "frontend", icon: "Palette" },
      { name: "Bootstrap", category: "frontend", icon: "Layout" },
      { name: "ShadCN", category: "frontend", icon: "Component" },
      {
        name: "Responsive Layout Techniques",
        category: "design",
        icon: "LayoutDashboard",
      },
      {
        name: "Figma & Dribbble-Style UI",
        category: "design",
        icon: "PenTool",
      },
      { name: "Flutter", category: "mobile", icon: "Smartphone" },
      { name: "Node.js", category: "backend", icon: "Cpu" },
      { name: "Express.js", category: "backend", icon: "Database" },
      { name: "NestJS", category: "backend", icon: "Server" },
      { name: "Native PHP", category: "backend", icon: "FileCode2" },
      { name: "Firebase", category: "backend", icon: "Cloud" },
      { name: "PostgreSQL", category: "database", icon: "Database" },
      { name: "MySQL", category: "database", icon: "HardDrive" },
      { name: "MongoDB", category: "database", icon: "Leaf" },
      { name: "Docker", category: "devops", icon: "Container" },
      { name: "VPS + Nginx Deployment", category: "devops", icon: "ServerCog" },
      { name: "Vercel Hosting", category: "devops", icon: "Triangle" },
      { name: "cPanel Hosting", category: "devops", icon: "PanelLeft" },
      { name: "Nginx", category: "devops", icon: "Network" },
      { name: "Git", category: "devops", icon: "GitBranch" },
      { name: "CI/CD", category: "devops", icon: "Workflow" },
      { name: "BPJS PCare API", category: "integration", icon: "ShieldCheck" },
      { name: "GPT API (OpenAI)", category: "integration", icon: "Brain" },
      { name: "Google Voice-to-Speech", category: "integration", icon: "Mic2" },
      { name: "Telegram Bot API", category: "integration", icon: "Send" },
      { name: "Google Maps Platform", category: "integration", icon: "MapPin" },
      {
        name: "Coordinate Region Mapping",
        category: "integration",
        icon: "Route",
      },
      { name: "YouTube API", category: "integration", icon: "Youtube" },
    ],
    languages: [
      { name: "Bahasa Indonesia", level: 100, proficiency: "Penutur asli" },
      { name: "Bahasa Inggris", level: 45, proficiency: "Kemampuan kerja" },
      { name: "Bahasa Arab", level: 40, proficiency: "Dasar" },
    ],
    education: {
      degree: "Sarjana Teknik Informatika",
      university: "Universitas Mataram",
      gpa: "3.88/4.00",
      period: "2020 - 2024",
      roles: [
        "Asisten Dosen - Algoritma & Struktur Data",
        "Asisten Dosen - Sistem Digital",
        "Asisten Dosen - Pengolahan Citra Digital",
      ],
      awards: [
        "Finalis GEMASTIK - Kompetisi TIK Nasional",
        "Best Paper Award - Konferensi Akademik",
        "Berpartisipasi di berbagai kompetisi nasional",
      ],
    },
    projects: [
      {
        id: 1,
        title: "AkuSehat",
        subtitle: "Platform Kesehatan Klinis",
        description:
          "Sistem kesehatan digital terintegrasi BPJS PCare dengan manajemen rekam medis, inventaris obat, dan dashboard analitik operasional klinik.",
        tech: ["React Vite", "Express.js", "PostgreSQL", "Node.js"],
        image: "/akusehat.png",
        category: "Kesehatan",
        color: "from-blue-600/20 to-cyan-500/20",
        liveUrl: "https://akusehat-poldantb-unram.icu",
        repoUrl: "https://github.com/ISENA-FKTP",
      },
      {
        id: 2,
        title: "Platform Sewa E-Bike",
        subtitle: "Gridwiz Dashboard Service - Energy and Mobility Indonesia",
        description:
          "Frontend Next.js dengan backend NestJS untuk layanan sewa sepeda listrik, dilengkapi pemesanan real-time, pembayaran, dan deployment VPS ber-Nginx.",
        tech: ["Next.js", "NestJS", "PostgreSQL", "Nginx"],
        image: "/gridwiz.png",
        category: "Mobilitas",
        color: "from-blue-500/20 to-cyan-500/20",
        liveUrl: "https://gridwizenm.com",
        repoUrl: "https://github.com/GridWiz-Apps",
      },
      {
        id: 3,
        title: "AyoTani",
        subtitle: "Platform Agritech",
        description:
          "Platform web full-stack yang menghubungkan petani dengan pemasok. Mencakup marketplace, manajemen stok, dan koordinasi logistik produk pertanian.",
        tech: ["React", "Node.js", "MongoDB", "Express"],
        image: "/ayotani.png",
        category: "Agritech",
        color: "from-green-500/20 to-emerald-500/20",
        liveUrl: "#",
        repoUrl: "https://github.com/Ayotani-Unram",
      },
      {
        id: 4,
        title: "KarirTerbuka",
        subtitle: "Platform Lowongan Kerja",
        description:
          "Website lowongan kerja inklusif yang menghubungkan perusahaan ramah disabilitas dengan pencari kerja umum. Dibangun dengan stack modern untuk aksesibilitas dan pembaruan real-time.",
        tech: [
          "TypeScript",
          "Tailwind CSS",
          "React.js",
          "Next.js",
          "MySQL",
          "Vercel",
        ],
        image: "/karirterbuka.png",
        category: "Portal Karier",
        color: "from-purple-500/20 to-pink-500/20",
        liveUrl: "https://karir-terbuka.vercel.app",
        repoUrl: "https://github.com/RusdyZain/KarirTerbuka",
      },
    ],
  },
};

export const DEFAULT_LANGUAGE = "en";
